export { default as JurisdictionAnalysisInfo } from './connector';
export * from './JurisdictionAnalysisInfo.proptype';
